"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeBuilder = void 0;
const myMap_1 = require("./util/myMap");
const designSystem_1 = require("./designSystem");
const index_1 = require("./storage/index");
/**
 * The main Theme Builder class.
 *
 * @category Main
 */
class ThemeBuilder {
    static setDefault(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.default) {
                throw new Error("ThemeBuilder.setDefault has already been called");
            }
            this.default = yield this.create(opts);
            return this.default;
        });
    }
    static getDefault() {
        if (!this.default) {
            throw new Error("ThemeBuilder.setDefault has not been called");
        }
        return this.default;
    }
    /**
     * Create a theme builder.
     * @param opts Theme Builder options.
     * @returns The ThemeBuilder object.
     */
    static create(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            return new ThemeBuilder(opts);
        });
    }
    constructor(opts) {
        this.designSystems = new myMap_1.MyMap();
        opts = opts || {};
        const storage = opts.storage || new index_1.MemStorage();
        this.storage = storage;
    }
    /**
     * Add a new design system to the theme builder.
     * @param name The name of the design system to add.
     * @param opts Optional arguments.  opts.sample=true if this is a sample design system.
     * @returns The new design system
     */
    addDesignSystem(name, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const ds = new designSystem_1.DesignSystem(name, this, opts);
            yield this.store(ds);
            return ds;
        });
    }
    /**
     * Get an existing design system by name
     * @param name The name of the design system to return.
     * @returns The design system with the specified name, or throws an error otherwise.
     */
    getDesignSystem(name) {
        return __awaiter(this, void 0, void 0, function* () {
            let ds = this.designSystems.get(name);
            if (!ds) {
                const obj = yield this.storage.get(name);
                if (!obj) {
                    throw new Error(`Design system '${name}' does not exist`);
                }
                ds = this.newDesignSystemFromObject(name, obj);
                this.designSystems.set(name, ds);
            }
            return ds;
        });
    }
    /**
     * Delete the design system named 'name'.
     *
     * @param name The name of the design system to delete.
     */
    deleteDesignSystem(name) {
        return __awaiter(this, void 0, void 0, function* () {
            let ds = this.designSystems.get(name);
            if (!ds) {
                const str = yield this.storage.get(name);
                if (!str) {
                    throw new Error(`Design system '${name}' does not exist`);
                }
            }
            else {
                this.designSystems.delete(name);
            }
            yield this.storage.delete(name);
        });
    }
    newDesignSystemFromObject(name, obj) {
        const ds = new designSystem_1.DesignSystem(name, this);
        ds.deserialize(obj);
        return ds;
    }
    /**
     * Get a list of all design system names.
     * @returns The list of all design system names.
     */
    listDesignSystemNames() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.storage.listKeys();
        });
    }
    listMetadata() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.storage.listMetadata();
        });
    }
    store(ds) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storage.set(ds.name, ds.serialize());
        });
    }
}
exports.ThemeBuilder = ThemeBuilder;
